function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  y: 12,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  y: 6,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  y: 18,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 12,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 6,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 18,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 12,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 12,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 6,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 18,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 6,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 18,
  className: "st0",
  width: 4,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 12,
  className: "st0",
  width: 4,
  height: 4
}));

var SvgGridSmall = function SvgGridSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGridSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grid-small.740e9550.svg";
export { ForwardRef as ReactComponent };